// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CultosEventos_cultosEventos__67ClB {
    padding: 2rem 1rem;
    background-color: #ffffff;
}

.CultosEventos_container__E6RaK {
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
}

h2 {
    font-size: 2rem;
    color: #333;
    margin-bottom: 1.5rem;
}

ul {
    list-style: none;
    padding: 0;
}

.CultosEventos_eventItem__ndG0Y {
    display: flex;
    align-items: center;
    background-color: #fff;
    padding: 1rem;
    margin-bottom: 1rem;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.363);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.CultosEventos_eventItem__ndG0Y:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.651);
    background-color: #f3f3f3;
}

.CultosEventos_eventDateContainer__xJ\\+uW {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.5rem 1rem;
    background-color: #0073e6;
    color: white;
    border-radius: 8px;
    margin-right: 1rem;
    min-width: 80px;
    box-sizing: border-box;
}

.CultosEventos_eventDate__oCuLd {
    font-size: 1.25rem;
    font-weight: bold;
}

.CultosEventos_eventTime__XXulP {
    font-size: 1rem;
}

.CultosEventos_eventDetails__\\+2vFS {
    flex: 1 1;
    border-left: 2px solid #0073e6;
    padding-left: 1rem;
}

.CultosEventos_eventTitle__mBZtV {
    font-size: 1.5rem;
    color: #333;
    margin-bottom: 0.5rem;
}

.CultosEventos_eventLocation__ETicF {
    font-size: 1rem;
    color: #555;
}

/* Media query para telas menores (tablet e celular) */
@media (max-width: 768px) {
    .CultosEventos_cultosEventos__67ClB {
        padding: 1.5rem 1rem;
    }

    h2 {
        font-size: 1.75rem;
        margin-bottom: 1rem;
    }

    .CultosEventos_eventItem__ndG0Y {
        flex-direction: column;
        align-items: center;
        padding: 1rem;
    }

    .CultosEventos_eventDateContainer__xJ\\+uW {
        width: 100%;
        /* Ocupa toda a largura disponível */
        padding: 0.5rem;
        margin: 0 0 0.5rem 0;
        /* Centraliza horizontalmente e adiciona espaço abaixo */
    }

    .CultosEventos_eventDate__oCuLd {
        font-size: 1rem;
    }

    .CultosEventos_eventTime__XXulP {
        font-size: 0.875rem;
    }

    .CultosEventos_eventDetails__\\+2vFS {
        border-left: none;
        padding-left: 0;
        text-align: center;
        width: 100%;
    }

    .CultosEventos_eventTitle__mBZtV {
        font-size: 1.25rem;
    }

    .CultosEventos_eventLocation__ETicF {
        font-size: 0.875rem;
    }
}

/* Ajustes para telas muito pequenas */
@media (max-width: 480px) {
    .CultosEventos_eventDateContainer__xJ\\+uW {
        max-width: 120px;
        /* Reduz ainda mais a largura máxima */
    }

    .CultosEventos_eventDate__oCuLd {
        font-size: 0.9rem;
    }

    .CultosEventos_eventTime__XXulP {
        font-size: 0.8rem;
    }

    .CultosEventos_eventTitle__mBZtV {
        font-size: 1.1rem;
    }

    .CultosEventos_eventLocation__ETicF {
        font-size: 0.8rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Site/CultosEventos/CultosEventos.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;IAC3C,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,sDAAsD;AACtD;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,oCAAoC;QACpC,eAAe;QACf,oBAAoB;QACpB,wDAAwD;IAC5D;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA,sCAAsC;AACtC;IACI;QACI,gBAAgB;QAChB,sCAAsC;IAC1C;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".cultosEventos {\r\n    padding: 2rem 1rem;\r\n    background-color: #ffffff;\r\n}\r\n\r\n.container {\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n    text-align: center;\r\n}\r\n\r\nh2 {\r\n    font-size: 2rem;\r\n    color: #333;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\nul {\r\n    list-style: none;\r\n    padding: 0;\r\n}\r\n\r\n.eventItem {\r\n    display: flex;\r\n    align-items: center;\r\n    background-color: #fff;\r\n    padding: 1rem;\r\n    margin-bottom: 1rem;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.363);\r\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.eventItem:hover {\r\n    transform: translateY(-5px);\r\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.651);\r\n    background-color: #f3f3f3;\r\n}\r\n\r\n.eventDateContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    padding: 0.5rem 1rem;\r\n    background-color: #0073e6;\r\n    color: white;\r\n    border-radius: 8px;\r\n    margin-right: 1rem;\r\n    min-width: 80px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.eventDate {\r\n    font-size: 1.25rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.eventTime {\r\n    font-size: 1rem;\r\n}\r\n\r\n.eventDetails {\r\n    flex: 1;\r\n    border-left: 2px solid #0073e6;\r\n    padding-left: 1rem;\r\n}\r\n\r\n.eventTitle {\r\n    font-size: 1.5rem;\r\n    color: #333;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.eventLocation {\r\n    font-size: 1rem;\r\n    color: #555;\r\n}\r\n\r\n/* Media query para telas menores (tablet e celular) */\r\n@media (max-width: 768px) {\r\n    .cultosEventos {\r\n        padding: 1.5rem 1rem;\r\n    }\r\n\r\n    h2 {\r\n        font-size: 1.75rem;\r\n        margin-bottom: 1rem;\r\n    }\r\n\r\n    .eventItem {\r\n        flex-direction: column;\r\n        align-items: center;\r\n        padding: 1rem;\r\n    }\r\n\r\n    .eventDateContainer {\r\n        width: 100%;\r\n        /* Ocupa toda a largura disponível */\r\n        padding: 0.5rem;\r\n        margin: 0 0 0.5rem 0;\r\n        /* Centraliza horizontalmente e adiciona espaço abaixo */\r\n    }\r\n\r\n    .eventDate {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .eventTime {\r\n        font-size: 0.875rem;\r\n    }\r\n\r\n    .eventDetails {\r\n        border-left: none;\r\n        padding-left: 0;\r\n        text-align: center;\r\n        width: 100%;\r\n    }\r\n\r\n    .eventTitle {\r\n        font-size: 1.25rem;\r\n    }\r\n\r\n    .eventLocation {\r\n        font-size: 0.875rem;\r\n    }\r\n}\r\n\r\n/* Ajustes para telas muito pequenas */\r\n@media (max-width: 480px) {\r\n    .eventDateContainer {\r\n        max-width: 120px;\r\n        /* Reduz ainda mais a largura máxima */\r\n    }\r\n\r\n    .eventDate {\r\n        font-size: 0.9rem;\r\n    }\r\n\r\n    .eventTime {\r\n        font-size: 0.8rem;\r\n    }\r\n\r\n    .eventTitle {\r\n        font-size: 1.1rem;\r\n    }\r\n\r\n    .eventLocation {\r\n        font-size: 0.8rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cultosEventos": `CultosEventos_cultosEventos__67ClB`,
	"container": `CultosEventos_container__E6RaK`,
	"eventItem": `CultosEventos_eventItem__ndG0Y`,
	"eventDateContainer": `CultosEventos_eventDateContainer__xJ+uW`,
	"eventDate": `CultosEventos_eventDate__oCuLd`,
	"eventTime": `CultosEventos_eventTime__XXulP`,
	"eventDetails": `CultosEventos_eventDetails__+2vFS`,
	"eventTitle": `CultosEventos_eventTitle__mBZtV`,
	"eventLocation": `CultosEventos_eventLocation__ETicF`
};
export default ___CSS_LOADER_EXPORT___;
